import { createSlice } from "@reduxjs/toolkit";

export const testSet = createSlice({
  name: "testSet",
  initialState: {
    correct: 0,
    incorrect: 0,
    correctIndexList: [],
    incorrectIndexList: [],
    markedList: [],
    selectedQuestion: 0,
    testSetId: "",
    questions: [],
    userAnswers: [],
    attemptedList: [],
  },
  reducers: {
    setCorrectCount: (state, action) => {
      state.correct = action.payload;
    },
    setInCorrectCount: (state, action) => {
      state.incorrect = action.payload;
    },
    setCorrectIndexList: (state, action) => {
      state.correctIndexList = [...action.payload];
    },
    setInCorrectIndexList: (state, action) => {
      state.incorrectIndexList = [...action.payload];
    },
    setSelectedQuestions: (state, action) => {
      state.selectedQuestion = action.payload;
    },
    setTestSetId: (state, action) => {
      state.testSetId = action.payload;
    },
    setQuestions: (state, action) => {
      state.questions = [...action.payload];
    },
    clearAll: (state) => {
      state.correct = 0;
      state.incorrect = 0;
      state.incorrectIndexList = [];
      state.correctIndexList = [];
      state.selectedQuestion = 0;
      state.testSetId = "";
      state.questions = [];
      state.markedList = [];
      state.userAnswers = [];
      state.attemptedList = [];
    },
    setMarkedList: (state, action) => {
      state.markedList = [...action.payload];
    },
    setUserAnswersList: (state, action) => {
      state.userAnswers = [...action.payload];
    },
    setAttemptedList: (state, action) => {
      state.attemptedList = [...action.payload];
    },
  },
});

// this is for dispatch
export const {
  setCorrectCount,
  setCorrectIndexList,
  setInCorrectCount,
  setInCorrectIndexList,
  setTestSetId,
  setSelectedQuestions,
  setQuestions,
  clearAll,
  setMarkedList,
  setAttemptedList,
  setUserAnswersList,
} = testSet.actions;

// this is for configureStore
export default testSet.reducer;
